"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tabs = _interopRequireDefault(require("@eig-builder/core-ui/Tabs"));

var _Tab = _interopRequireDefault(require("@eig-builder/core-ui/Tab"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _doubleRafHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/double-raf-helper"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _context = _interopRequireDefault(require("@eig-builder/module-localization/context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: ", ";\n  bottom: ", ";\n  @media screen and (max-width: 720px) {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: 720px) {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TAB_CLASS = 'tab-element';
var StyledTabs = (0, _styledComponents.default)(function (_ref) {
  var isTop = _ref.isTop,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["isTop", "theme"]);

  return _react.default.createElement(_Tabs.default, props);
})(_templateObject(), function (props) {
  return props.isTop && props.theme ? "".concat(props.theme.spacing(3), "px") : 'auto';
});

var PositionDiv = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.isTop ? 'relative' : 'absolute';
}, function (props) {
  return props.isTop ? 'auto' : 0;
});

var TabsComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(TabsComponent, _Component);

  function TabsComponent(props) {
    var _this;

    _classCallCheck(this, TabsComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabsComponent).call(this, props));

    _this.setInkbarStyle = function () {
      (0, _doubleRafHelper.default)(function () {
        // Wait for render so we can get the DOM node
        var node = _reactDom.default.findDOMNode(_assertThisInitialized(_this));

        var childNodes = document.querySelectorAll('.' + TAB_CLASS, node);
        var currentNode = childNodes[_this.props.currentTab];

        _this.setState({
          activeTabWidth: currentNode.clientWidth,
          activeTabLeft: currentNode.offsetLeft
        });
      });
    };

    _this.handleTabChange = function (e, value) {
      if (_this.props.onTabChange) {
        _this.props.onTabChange(e, value);
      }
    };

    _this.textWidth = function (string) {
      return string.length * 8.64; // empirical proven value, this can never be wrong
    };

    _this.tabWidth = function () {
      var max = Math.max.apply(null, _this.props.tabs.map(function (i) {
        if (i.label.props && i.label.props.message) {
          return _this.textWidth(_this.context.localize(i.label.props.message, i.label.props.values));
        }

        return _this.textWidth(i.label);
      })); // some best effort to find the tab width

      return (max + 20) * _this.props.tabs.length * 1.05;
    };

    _this.renderTab = function (model) {
      var index = _this.props.tabs.indexOf(model);

      return _react.default.createElement(_Tab.default, {
        label: model.label,
        key: model.key,
        value: index,
        dataElementLocation: _this.props.dataElementLocation,
        dataElementLabel: _this.props.dataElementLabelPrefix + '_' + model.key,
        dataElementId: _this.props.dataElementIdPrefix + '_' + model.key
      });
    };

    _this.state = {
      tabColor: props.tabColor || (0, _runtimeConfigHelper.getRuntimeConfig)()._brandVariables.primaryBackgroundColor
    };

    if (props.autoWidth) {
      // Random initial value, is set to the right width after the first render
      _this.state.activeTabWidth = '200px';
      _this.state.activeTabLeft = 0;
    }

    return _this;
  }

  _createClass(TabsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setInkbarStyle();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          inverted = _this$props.inverted,
          tabs = _this$props.tabs;
      var tabColor = inverted ? '#fff' : this.state.tabColor;
      var inkBarStyle = {
        backgroundColor: tabColor,
        height: '3px',
        color: '#fff'
      };

      if (this.props.autoWidth) {
        inkBarStyle.width = this.state.activeTabWidth;
        inkBarStyle.left = this.state.activeTabLeft;
      }

      return _react.default.createElement("div", {
        className: this.props.rootClassName
      }, _react.default.createElement(PositionDiv, {
        isTop: this.props.isTop
      }, _react.default.createElement(StyledTabs, {
        value: this.props.currentTab,
        onChange: this.handleTabChange,
        variant: "scrollable",
        scrollButtons: "off" // tabItemContainerStyle={tabBackgroundColor}
        // contentContainerStyle={{ 'color': tabColor }}
        ,
        TabIndicatorProps: {
          style: {
            background: '#0082ED',
            height: 3
          }
        },
        ref: this.tabRef,
        isTop: this.props.isTop
      }, tabs.map(function (tab) {
        return _this2.renderTab(tab);
      }))));
    }
  }]);

  return TabsComponent;
}(_react.Component);

TabsComponent.contextType = _context.default;
TabsComponent.propTypes = {
  onTabChange: _propTypes.default.func,
  tabs: _propTypes.default.array,
  tabColor: _propTypes.default.string,
  inverted: _propTypes.default.bool,
  autoWidth: _propTypes.default.bool,
  currentTab: _propTypes.default.number.isRequired,
  isTop: _propTypes.default.bool,
  rootClassName: _propTypes.default.string,
  dataElementLocation: _propTypes.default.oneOf(_taggingHelper.DataElementLocationsArray).isRequired,
  dataElementLabelPrefix: _propTypes.default.string.isRequired,
  dataElementIdPrefix: _propTypes.default.string.isRequired
};
TabsComponent.defaultProps = {
  rootClassName: 'container'
};
var _default = TabsComponent;
exports.default = _default;